import React from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Popover, PopoverTitle, PopoverContent, Button, Collapse, Navbar, NavbarToggler, NavbarBrand, Nav, NavItem, NavLink } from 'reactstrap';
import moment from 'moment';
const axios = require('axios');

export default class Navigation extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            isOpen: false,
            popoverOpen: false,
            modal: false,
            logs: [],
            logsLoaded: false
        };

        this.toggle = this.toggle.bind(this);
        this.toggleModal = this.toggleModal.bind(this);
        this.toggleInfobox = this.toggleInfobox.bind(this);
        this.getLogs = this.getLogs.bind(this);
        this.printLogs = this.printLogs.bind(this);
        this.clearLogs = this.clearLogs.bind(this);
    }

    getLogs() {
        fetch(this.props.restIp+'/logs/0')
            .then(function(response) {
                return response.json()
            })
            .then(function(json) {
                this.setState({
                    logs: json,
                    logsLoaded: true
                });
            }.bind(this)).catch(function(ex) {
            console.log('parsing failed', ex)
        });
    }

    componentDidMount() {
        this.getLogs();

        setInterval(this.getLogs, 30000);
    }

    toggleModal() {
        this.setState({
            modal: !this.state.modal
        });

        if(!this.state.modal) this.toggleInfobox();
    }

    toggle() {
        this.setState({
            isOpen: !this.state.isOpen
        });
    }

    toggleInfobox() {
        this.setState({
            popoverOpen: !this.state.popoverOpen
        });
    }

    printLogs(num) {
        let resp =[];
        let BreakException= {};

        if(this.state.logsLoaded) {
            if(num) {
                let i = 0;
                try {
                    this.state.logs.forEach(function (item) {
                        resp.push(<span>{item.message}<br /><small>{moment(item.date).format('DD/MM/YYYY HH:mm')}</small>{i+1!==num && <hr />}</span>);
                        i++;
                        if(i>=num) throw BreakException;
                    })
                } catch(e) {
                    if (e!==BreakException) throw e;
                }
            }
        }
        return resp;
    }

    clearLogs() {
        axios.post(this.props.restIp+'/logs/clear')
            .then(function (response) {
                if(response.data.status === 'OK') {
                    this.getLogs();
                    alert('Logi zostały wyczyszczone');
                }
                else
                    alert('Wystapił bład')
            }.bind(this))
            .catch(function (error) {
                console.log(error);
            });
    }

    render() {
        return (
            <div>
                <Navbar color="dark" dark expand>
                    <NavbarToggler onClick={this.toggle} />
                    <NavbarBrand href="/">3D Meteo</NavbarBrand>
                    <Collapse isOpen={this.state.isOpen} navbar>
                        <Nav className="ml-auto" navbar>
                            {/* <NavItem style={{marginRight: '5px'}}>
                                <Button id="Popover1" onClick={this.toggleInfobox} color="primary"><i className="fa fa-flag-o" aria-hidden="true"></i></Button>
                            </NavItem>
                            <Popover placement="bottom" isOpen={this.state.popoverOpen} target="Popover1" toggle={this.toggleInfobox} style={{width: "250px"}}>
                                <PopoverTitle>Powiadomienia</PopoverTitle>
                                <PopoverContent>
                                    {this.printLogs(3)}
                                </PopoverContent>
                                <h3 className="popover-footer text-center" onClick={this.toggleModal}>Więcej</h3>
                            </Popover> */}

                            {/* <span className="navbar-text">
                                Witaj <span className={this.props.admin ? 'text-info' : ''}>{this.props.handle}</span>
                            </span>
                            <NavItem>
                                <NavLink onClick={() => this.props.logoutAction()}>Wyloguj</NavLink>
                            </NavItem> */}
                        </Nav>
                    </Collapse>
                </Navbar>
                <Modal isOpen={this.state.modal} toggle={this.toggleModal} size="lg">
                    <ModalHeader toggle={this.toggleModal}>Zapisy alertów</ModalHeader>
                    <ModalBody style={{maxHeight: '70vh', overflowY: 'scroll'}}>
                        {this.printLogs(50)}
                    </ModalBody>
                    <ModalFooter>
                        <Button color="danger" onClick={this.clearLogs}>Wyczyść listę</Button>{' '}
                        <Button color="secondary" onClick={this.toggleModal}>Zamknij</Button>
                    </ModalFooter>
                </Modal>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/Navigation.js